const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKortReverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 780.1 647.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a53cf932-03db-4c70-9272-13b53e4d8d4a",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f2afd295-843e-4318-82a1-96a0250dab32",
    "data-name": "a928d488-6e6c-46d7-ac2c-f12f8bd647b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M743.44,84.36a50.3,50.3,0,0,1,35.06,61h0l-.27,1L647.68,611.87c-6,21.59-25.95,34.67-48.38,34.67a49.94,49.94,0,0,1-13.54-1.87l-183-49,.54-1.93,183,49a48.11,48.11,0,0,0,13,1.8c21.54,0,40.64-12.48,46.46-33.21L776,146.71l.29-1A48.31,48.31,0,0,0,742.9,86.28L448.7,3.79A48.29,48.29,0,0,0,389.24,37.2L379,73.66l-1.92-.54,10.22-36.46a50.3,50.3,0,0,1,61.92-34.8Z",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.9,86.28a48.31,48.31,0,0,1,33.43,59.42l-.29,1L645.76,611.33c-5.82,20.73-24.92,33.21-46.46,33.21a48.11,48.11,0,0,1-13-1.8l-183-49-3.34-71.63,2.38-.11,188.5,52.86,1,.27L711.11,149.55l.27-1L444.19,73.66l-1-.27L402.37,219.08l-14.18,51.16L379,73.66,389.24,37.2A48.29,48.29,0,0,1,448.7,3.79Z",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "711.38 148.59 711.11 149.55 591.77 575.14 590.81 574.87 402.31 522.01 402.85 520.08 590.39 572.67 708.92 149.97 444.61 75.86 404.3 219.63 402.37 219.08 443.23 73.39 444.19 73.66 711.38 148.59",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.3 219.63 388.4 274.76 388.19 270.24 402.37 219.08 404.3 219.63",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.93 522.12 403.27 593.75 402.73 595.68 377.1 73.12 379.02 73.66 388.19 270.24 387.95 271.09 388.32 275.03 388.4 274.76 399.93 522.12",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.19 270.24 388.4 274.76 388.32 275.03 387.95 271.09 388.19 270.24",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,115V598.49a47.29,47.29,0,0,1-47.23,47.23H49.23A47.29,47.29,0,0,1,2,598.49V115A47.28,47.28,0,0,1,49.23,67.72H354.77A47.06,47.06,0,0,1,389,82.46q.74.78,1.44,1.59A47.13,47.13,0,0,1,402,115ZM339.75,576.76v-441H63.25v441h276.5Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.24,574.76h9.66a17.79,17.79,0,0,1-1.66,2h-7.42C259.65,576.09,259.46,575.42,259.24,574.76Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.75,135.76v441H267.24a17.79,17.79,0,0,0,1.66-2h68.85v-437H65.25v437h194c.22.66.41,1.33.58,2H63.25v-441Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,598.49V115a47.13,47.13,0,0,0-11.54-30.9q-.7-.81-1.44-1.59a47.06,47.06,0,0,0-34.25-14.74H49.23A47.28,47.28,0,0,0,2,115V598.49a47.29,47.29,0,0,0,47.23,47.23H354.77A47.29,47.29,0,0,0,402,598.49ZM0,115A49.27,49.27,0,0,1,49.23,65.72H354.77a49.1,49.1,0,0,1,34.87,14.5A49.78,49.78,0,0,1,393.81,85,49.07,49.07,0,0,1,404,115V598.49a49.29,49.29,0,0,1-49.23,49.23H49.23A49.29,49.29,0,0,1,0,598.49Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484,328.78s-5.06,32.85-6.56,34.51,10.5,40.33,10.5,40.33l38.49-22.44s7.49-41.52,10-42.91S484,328.78,484,328.78Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484,328.78s-5.06,32.85-6.56,34.51,10.5,40.33,10.5,40.33l38.49-22.44s7.49-41.52,10-42.91S484,328.78,484,328.78Z",
    style: {
      isolation: "isolate",
      opacity: 0.10000000149011612
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.74,
    cy: 322.59,
    r: 38,
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.27,381.32l-3.31-3-14.89-21.18s-1.71-1.12-3.33,4.65l-1.62,5.78-14,5.43L429.2,505.56,512,528.78l34.1-132.73-16-16.95-1.78-8.18L503.59,381Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.56,519.14l2,.56,129,36.16,43.12-142.65s-10.2-8.06-18.18-9.26c0,0-13.4-15.18-19.17-16.8s-12.17-15.87-12.17-15.87-6.75,24.07-18.35,39.51-31.8,69-31.8,69l-5.7-98.19,6.4-24.69A45.6,45.6,0,0,0,468.61,365c-4.51,5-16,9-16,9s-30.32,8.12-35.68,8.7-7.82,2-7.82,2l-3.53,24.29-2,13.76Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.16,463.84c-1.2,8-13.54,40.86-13.54,40.86l-2.06,2.07-2,2V387a5.68,5.68,0,0,1,2-1.39,13.55,13.55,0,0,1,3.53-.94l3.86,1.08S422.36,455.86,421.16,463.84Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509,506.12s18.92-34.15,33.25-26S533.62,511,533.62,511Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.43,492.81s-36.32-11.22-37.13-8.33-10.76,19.83-7.87,20.64,25.31,6.06,25,7,10.74,6.13,10.74,6.13Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.12 528.49 455.56 536.05 404.56 522.05 403.56 519.14 403.56 503.11 405.56 503.89 407.63 504.7 459.12 528.49",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,495.78s-12-5.43-12.25-4.47S432.43,520,436.28,521s17.48,8,17.48,8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.9,411.32l6.74,1.89s3.86,1.08,4.16,7.39,5.53,35.83,3.07,37.21-3.16.16-1.77,2.62,2.61,1.77,1.11,3.43-5,54.69-16.13,72.33-14.57,26-18.42,25l-99.83-28s4.45-39.26,8.57-39.14S530,508.91,530,508.91,556.19,408.23,570.9,411.32Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.35,280.94l-6.24-4.47S503.7,266,523.54,273l-4.08-7.28s15.3-1.15,24.2,15.64c4.68,8.83,10.07,19.17,12.26,29.74l7.44,2.08-4.84,5.34,9.12,9.25-10.84-4.24a32.58,32.58,0,0,1-5.56,15.78l-4.47,6.23s-4.44-23-3.73-25.55l-1.77,6.31s-5.35-7.63-4.29-11.41l-5,3.35,0-7.47-25.3.39,5.38-4.62-15-2.17,7.62-5.35s-18.71,3.6-21.28,10.37-13.26,13.3-13.26,13.3l-2-7.38S470.39,285.27,491.35,280.94Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(107.51 376.77) rotate(-0.02)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#ffc539",
      fontFamily: "Chalkduster",
      letterSpacing: "-0.06600167410714286em"
    }
  }, "P"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(152.6 376.75) rotate(-0.02)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#2d4059",
      fontFamily: "Chalkduster",
      letterSpacing: "-0.051004464285714285em"
    }
  }, "a"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(197.23 376.74) rotate(-0.02)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#2d4059",
      fontFamily: "Chalkduster",
      letterSpacing: "0.0009974888392857142em"
    }
  }, "r"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(234.21 376.72) rotate(-0.02)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#2d4059",
      fontFamily: "Chalkduster",
      letterSpacing: "0.0049944196428571425em"
    }
  }, "t"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(266.54 376.71) rotate(-0.02)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#2d4059",
      fontFamily: "Chalkduster"
    }
  }, "i")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKortReverse);
export default __webpack_public_path__ + "static/media/kort-reverse.efd85b36b2d9289fa0bdcdc0984c669a.svg";
export { ForwardRef as ReactComponent };